/* src/components/project-risk-dossier/project-risk-dossier.component.scss */
app-project-risk-dossier {
  display: block;
}
.content-viewport {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 5rem;
  left: 0;
  width: 100vw;
  height: calc(100vh - 5rem);
}
.content-viewport__title {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 6rem;
  min-height: 6rem;
  max-height: 6rem;
  padding: 0 var(--padding-x);
  box-shadow: 0 0 3rem 0 rgba(0, 0, 0, 0.1);
}
.content-viewport__scrollable {
  position: relative;
  z-index: 1;
  width: 100%;
  height: calc(100% - 6rem);
  overflow: auto;
}
.content-viewport__table {
  position: relative;
  z-index: 1;
  width: 150rem;
  padding: var(--padding-x);
}
.pdf-page__risks-opportunities-quantification-grid {
  font-size: 0.8em;
  max-width: 90em;
}
.pdf-page__risks-opportunities-table {
  --padding-side: $size !important;
  --vwui-size-spacing-lg: $size;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.8rem;
  line-height: 0.88rem;
}
.pdf-page__risks-opportunities-table thead th {
  vertical-align: bottom;
  text-align: center;
  font-weight: 500;
  border: 1px solid var(--vwui--color--border-light);
  padding: 0.8rem;
}
.pdf-page__risks-opportunities-table tbody td {
  vertical-align: top;
  text-align: left;
  border: 1px solid var(--vwui--color--border-light);
  padding: 0.8rem;
}
.pdf-page__risks-opportunities-table tfoot {
  display: none;
}
.pdf-page__risks-opportunities-table thead th,
.pdf-page__risks-opportunities-table thead td,
.pdf-page__risks-opportunities-table tbody th,
.pdf-page__risks-opportunities-table tbody td {
  word-wrap: break-word;
}
.pdf-page__risks-opportunities-table thead th.vertical-label,
.pdf-page__risks-opportunities-table thead td.vertical-label,
.pdf-page__risks-opportunities-table tbody th.vertical-label,
.pdf-page__risks-opportunities-table tbody td.vertical-label {
  vertical-align: bottom;
  height: 8.8rem;
}
.pdf-page__risks-opportunities-table thead th.center-number,
.pdf-page__risks-opportunities-table thead td.center-number,
.pdf-page__risks-opportunities-table tbody th.center-number,
.pdf-page__risks-opportunities-table tbody td.center-number {
  text-align: center;
  padding: 0.8rem 0;
  white-space: nowrap;
}
.pdf-page__risks-opportunities-table thead th.col-checkbox,
.pdf-page__risks-opportunities-table thead td.col-checkbox,
.pdf-page__risks-opportunities-table tbody th.col-checkbox,
.pdf-page__risks-opportunities-table tbody td.col-checkbox {
  background-color: var(--vwui-color-neutral-4);
  width: 2rem;
  padding: 0.4rem;
}
.pdf-page__risks-opportunities-table thead td.col-checkbox,
.pdf-page__risks-opportunities-table tbody td.col-checkbox {
  vertical-align: top;
}
.pdf-page__risks-opportunities-table thead th.col-checkbox,
.pdf-page__risks-opportunities-table tbody th.col-checkbox {
  vertical-align: bottom;
}
.pdf-page__risks-opportunities-table .pdf-icon-size {
  display: inline-block;
  vertical-align: top;
  font-size: 0.8rem;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.pdf-page__risks-opportunities-table .table-legends__item {
  margin: 0.2rem 0 0 0;
  padding: 0 0 0 1.08rem;
}
.pdf-page__risks-opportunities-table .table-legends__icon {
  --vwui-icon--size: 0.8rem;
  display: inline-block;
  vertical-align: top;
  font-size: 0.8rem;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.pdf-page__risks-opportunities-table .table-legends-vertical__icon {
  --vwui-icon--size: 0.8rem;
  display: inline-block;
  vertical-align: top;
  font-size: 0.8rem;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.pdf-page__risks-opportunities-table-col-highlight {
  background-color: var(--vwui-color-neutral-4);
}
.pdf-page__risks-opportunities-table-vertical-label {
  display: inline-block;
  vertical-align: bottom;
  width: 7.2rem;
  white-space: nowrap;
  transform: rotate(270deg) translateX(-0.88rem);
  transform-origin: 0 0;
  text-align: left;
}
.pdf-page__risks-opportunities-table-title {
  font-weight: 500;
}
.pdf-page__risks-opportunities-table-text {
  font-weight: normal;
  margin: 0.2rem 0;
}
.pdf-page__risks-opportunities-table-text vwui-icon {
  --vwui-icon--size: 0.8rem;
  display: inline-block;
  vertical-align: top;
  margin: 0 0.4rem -0.8rem 0;
}
.pdf-page__risks-opportunities-table-label {
  position: relative;
  padding: 0 0 0 3.6rem;
  margin: 0.4rem 0 0 0;
}
.pdf-page__risks-opportunities-table-label--wide {
  padding-left: 4.8rem;
}
.pdf-page__risks-opportunities-table-label[title]::before {
  display: block;
  white-space: nowrap;
  font-weight: 500;
  content: attr(title);
  position: absolute;
  top: 0;
  left: 0;
}
.pdf-page__risks-opportunities-table-col-number {
  width: 1.5%;
}
.pdf-page__risks-opportunities-table-col-category {
  width: 11%;
}
.pdf-page__risks-opportunities-table-col-description {
  width: 23.5%;
}
.pdf-page__risks-opportunities-table-col-status {
  width: 5.5%;
}
.pdf-page__risks-opportunities-table-col-remarks {
  width: 22.5%;
}
.filters-toggle {
  transform: translateY(0.75rem);
}
.filters-selected {
  position: relative;
  z-index: 2;
  background: #fff;
  padding: var(--padding-x) var(--padding-x) calc(var(--padding-x) - var(--vwui-size-spacing-base)) var(--padding-x);
}
.filters-selected--hidden {
  display: none;
}
@media (min-height: 860px) {
  .filters-selected {
    position: sticky;
    top: 0;
    left: 0;
    box-shadow: 0 0 3rem 0 rgba(0, 0, 0, 0.1);
  }
}
/*# sourceMappingURL=project-risk-dossier.component-THCYZ6O3.css.map */
